// extracted by mini-css-extract-plugin
export default {"container":"AssetPanelConfiguration_container__ldphJ","accordions":"AssetPanelConfiguration_accordions__gXz93"};